import { getEntityStatusMeta } from '../../data/entityStatusConfig';

function EntityStatusBadge({ status }) {
  const statusMeta = getEntityStatusMeta(status);

  return (
    <span
      className={`inline-flex min-w-[104px] items-center justify-center rounded-full px-3 py-1 text-[0.72rem] font-semibold uppercase tracking-[0.12em] ring-1 ${statusMeta.className}`}
    >
      {statusMeta.label}
    </span>
  );
}

export default EntityStatusBadge;
